// extracted by mini-css-extract-plugin
module.exports = {"root":"HeadlineSection_root__6zMdm","standalone":"HeadlineSection_standalone__9k6tG"};